module.exports = __webpack_public_path__ + "static/media/SF_nn_sekundaerlogo_postale_vestfold_telemark_neg.8e0cda41.png";